export default "__VITE_ASSET__1cc5cdea__"